module.exports = __webpack_public_path__ + "img/56.e16b6d22.png";